<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Sync Fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <!-- <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Child</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list" item-text="name" item-value="lid" label="Child" outlined persistent-hint hint="Please Select Child" />
                    </v-col> -->
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Academic Year</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="ay">
                <!-- <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncOldTransportInstallments()">Sync Transportation</v-btn>
                      </v-col>
                       <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncOldCanteenInstallments()">Sync Canteen</v-btn>
                      </v-col>
                       <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncComponentSelectionTransport()">Sync Selection Transport</v-btn>
                      </v-col>
                       <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncComponentSelectionCanteen()">Sync Selection Canteen</v-btn>
                      </v-col>
                       <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncStudentLeaves()">Sync Student Leaves</v-btn>
                      </v-col>
                       <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncStudentFeesSelection()">Sync Student Fees Component Selection</v-btn>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="sendNotifications()">Send Notifications</v-btn>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                         <v-btn class="button" color="warning" dense @click="syncMobiles()">Sync Mobile</v-btn>
                      </v-col> -->
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="syncRelativeInfo()">Sync Relative Info</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="syncNames()">Sync Due Dates</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="syncRelativeNamesData()">Sync Relative Names</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="runJob()">Run job WWS Fees Reminder</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="runJobLeaveApprove()">Run Leave Approve Job</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <br />

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Unapprove Applications</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Child</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list" item-text="name" item-value="lid" label="Child" outlined persistent-hint hint="Please Select Child" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Academic Year</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="ay && child">
                <v-col cols="12" sm="2" md="2">
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="unapproveTransportInstallments()">Unapprove Transportation</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="unapproveCanteenInstallments()">Unapprove Canteen</v-btn>
                </v-col>
            </v-row>

            <v-row justify="center" dense v-if="ay && child">
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="fetchLearnerAssessmentMarks()">Fetch Marks</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-card class="box" v-if="marks_details!=''">
            <v-data-table :headers="headers" :items="marks_details" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Marks</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.comment`]="{ item }">
                    <v-textarea outlined dense type="text" v-model="item.comment" label="Comment"></v-textarea>

                    <v-btn class="button" color="warning" dense @click="updateComment(item.comment,item.id)">Update</v-btn>
                </template>

            </v-data-table>
        </v-card>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Delete Course Offering Instructor</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Instructor</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined persistent-hint hint="Please Select Instructor" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Academic Year</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="ay && instructor">
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="getInstructorCourses()">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="coi_list!=''">
            <v-data-table :headers="headers2" :items="coi_list" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <v-avatar size="25" class="edit-avatar">
                        <v-icon class="mr-4 v-icon-size" @click="deleteCOI(item)" color="red">mdi-trash-can</v-icon>
                    </v-avatar>
                </template>
            </v-data-table>
        </v-card>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Delete Leave And Sync Attendance</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Instructor</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined persistent-hint hint="Please Select Instructor" />
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="instructor">
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" color="warning" dense @click="getEmployeeLeaveTransactions()">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="leave_data!=''">
            <v-data-table :headers="headers3" :items="leave_data" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.can_delete`]="{ item }">
                  <span v-if="item.can_delete">
                      <v-avatar size="25" class="edit-avatar">
                          <v-icon class="mr-4 v-icon-size" @click="deleteLeaveAndSyncAttendance(item)" color="red">
                              mdi-trash-can
                          </v-icon>
                      </v-avatar>
                  </span>
                  <span v-else>--</span> <!-- Display `--` when deletion is not allowed -->
              </template>
            </v-data-table>
        </v-card>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        leave_data: [],
        instructor_list: [],
        instructor: "",
        coi_list: [],
        loader: false,
        snackbar_msg: "",
        username: "",
        color: "",
        snackbar: false,
        overlay: false,
        awspath: null,
        ay_list: [],
        ay: "",
        child_list: [],
        child: "",
        aws_path: null,
        search: '',
        marks_details: [],
        headers: [{
                text: "Sr No",
                value: "count"
            },
            {
                text: "courseoffering",
                value: "courseoffering"
            },
            {
                text: "evaluated_marks",
                value: "evaluated_marks"
            },
            {
                text: "converted_marks",
                value: "converted_marks"
            },
            {
                text: "courseofferinginstructor",
                value: "courseofferinginstructor"
            },
            // { text: "isabsent", value: "isabsent" },
            // { text: "medical_leave", value: "medical_leave" },
            {
                text: "assesmentschemedetails",
                value: "assesmentschemedetails"
            },
            // { text: "standard", value: "standard" },
            // { text: "divisionoffering", value: "divisionoffering" },
            // { text: "assesmentschemedetails", value: "assesmentschemedetails" },
            {
                text: "gradingschemedetails",
                value: "gradingschemedetails"
            },
            {
                text: "comment",
                value: "comment"
            }
        ],
        headers2: [{
                text: "Sr No",
                value: "count"
            },
            {
                text: "course",
                value: "course"
            },
            {
                text: "academicyear",
                value: "academicyear"
            },
            {
                text: "standard",
                value: "standard"
            },
            {
                text: "division",
                value: "division"
            },
            {
                text: "homework_count",
                value: "homework_count"
            },
            {
                text: "Delete",
                value: "delete"
            }
        ],
        headers3: [
      { text: "Application Date", value: "application_date", sortable: true },
      { text: "From Date", value: "fromdate", sortable: true },
      { text: "To Date", value: "todate", sortable: true },
      { text: "Number of Days", value: "numberofdays", sortable: true },
      { text: "Reason", value: "reason", sortable: false },
      { text: "Remark", value: "remark", sortable: false },
      { text: "Leave Type", value: "leave_type", sortable: true },
      { text: "Approval Status", value: "approval_status", sortable: true },
      { text: "Actions", value: "can_delete", sortable: false }
    ]
    }),
    created() {
        this.aws_path = localStorage.getItem("awspath");
    },
    methods: {
        deleteLeaveAndSyncAttendance(item) {
            this.coi_list = []
            const data = {
              transactionId: item.id
            };
            this.overlay = true;
            axios
                .post("/TryNError/deleteLeaveAndSyncAttendance", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.coi_list = res.data.coi_details
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getEmployeeLeaveTransactions() {
            this.coi_list = []
            const data = {
                instructor: this.instructor
            };
            this.overlay = true;
            axios
                .post("/TryNError/getEmployeeLeaveTransactions", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.leave_data = res.data.leaveDetailsMap
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        runJobLeaveApprove() {
            axios
                // .post("/TryNError/syncStudentNameData",data) 
                .post("/TryNError/runJobLeaveApprove")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        runJob() {
            axios
                // .post("/TryNError/syncStudentNameData",data) 
                .post("/TryNError/runJob")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        deleteCOI(item) {
            this.coi_list = []
            const data = {
                coi_id: item.id,
            };
            this.overlay = true;
            axios
                .post("/TryNError/deleteCourseOfferingInst", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Deleted Successfully...");
                        this.getInstructorCourses();
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", "something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getInstructorCourses() {
            this.coi_list = []
            const data = {
                academicyear: this.ay,
                instructor: this.instructor
            };
            this.overlay = true;
            axios
                .post("/TryNError/getCoffInst", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.coi_list = res.data.coi_details
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        syncRelativeNamesData() {
            if (!confirm("Are You Sure You Want To Sync.....?")) return;
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/TryNError/syncStudentRelativeNameData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncNames() {
            if (!confirm("Are You Sure You Want To Sync.....?")) return;
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                // .post("/TryNError/syncStudentNameData",data) 
                .post("/TryNError/syncStudentNameData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncRelativeInfo() {
            if (!confirm("Are You Sure You Want To Sync.....?")) return;
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/TryNError/syncRelativeData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncMobiles() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/TryNError/syncMobileNumbersAndEmail", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        updateComment(comment, assessment_id) {
            const data = {
                comment: comment,
                assessment_id: assessment_id
            };
            this.overlay = true;
            axios
                .post("/TryNError/saveLearnerAssessmentMarksComment", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.fetchLearnerAssessmentMarks()
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        fetchLearnerAssessmentMarks() {
            this.marks_details = []
            const data = {
                ay: this.ay,
                learner_id: this.child
            };
            this.overlay = true;
            axios
                .post("/TryNError/fetchLearnerAssessmentMarks", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.marks_details = res.data.marks_details
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        sendNotifications() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/AccountingAndFees/installmentNotifications", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncStudentFeesSelection() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/TryNError/syncStudentFeesComponentSelection", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncStudentLeaves() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/TryNError/syncStudentLeaves", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncStudentLeaves() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/TryNError/syncStudentLeaves", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        syncComponentSelectionTransport() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/ParentTransport/syncTransportComponentSelection", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncComponentSelectionCanteen() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/Canteen/syncCanteenComponentSelection", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        unapproveCanteenInstallments() {
            const data = {
                ay: this.ay,
                learner_id: this.child
            };
            this.overlay = true;
            axios
                .post("/Canteen/unmarkCanteenRequest", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Unapproved Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        unapproveTransportInstallments() {
            const data = {
                ay: this.ay,
                learner_id: this.child
            };
            this.overlay = true;
            axios
                .post("/ParentTransport/unmarkTransportRequest", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Unapproved Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncOldCanteenInstallments() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/Canteen/syncOldCanteenInstallments", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        syncOldTransportInstallments() {
            const data = {
                ay: this.ay
            };
            this.overlay = true;
            axios
                .post("/ParentTransport/syncOldTransportInstallments", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Synced Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        onLoad() {
            axios
                .post("/ParentTransport/syncTransportCanteen")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                        this.child_list = res.data.learner_list;
                        this.instructor_list = res.data.instructor_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },

    mounted() {
        this.onLoad();
    },
    created() {
        this.awspath = localStorage.getItem('awspath')
    },
    watch: {},
};
</script>

<style scoped>
.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

sub-row {
    border: 2px solid #424093;
    margin: 1rem;
    border-radius: 5px;
}

i {
    font-size: 20px !important;
}

.v-card__title {
    border: 1px solid #80808040;
    font-weight: bold;
    background-color: #424093;
    color: white;
    text-align: center;
    /* margin-top: 1.5rem; */
}

.card-border {
    border: 2px solid darkblue;
    border-radius: 10px;
    /* padding: 5px; */
    /* margin: 1rem !important; */
    width: auto;
}

.tx-bold {
    font-weight: bold;
    font-size: 14px;
    color: black;
}

i {
    font-size: 26px;
    cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #424093 !important;
    color: white !important;
    margin-top: 2.35rem;
    border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {}

.imgs {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px;
    cursor: zoom-in;
}

.imgs-preview {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: auto;
}

v-simple-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: auto;
    border: 1px solid #ddd;
}

th {
    color: white;
    font-weight: bold;
    text-align: center !important;
}

td,
th {
    padding: 6px;
    border: 1px solid #ccc;
    text-align: center;
}

@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

@media all and (min-width: 1000px) {
    .padding-metting {
        padding-right: 22px;
    }
}

@media (min-width: 320px) and (max-width: 350px) {
    .padding-bot {
        font-size: 11.6px;
    }
}

@media (min-width: 1000px) and (max-width: 1050px) {
    .padding-bot {
        font-size: 9.6px;
    }
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.note-list {
    background-color: orange;
}
</style>
